import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

import { buildLocalizedPagePath } from "./localized-page-path";

export type LegalPage = "privacy" | "terms";

export function buildLegalPagePath(locale: ViewerLocale, page: LegalPage): string {
  return buildLocalizedPagePath(locale, page);
}
